/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Meta_Shown_Legends_PartialInputs */



/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{shownFormatted} of {totalFormatted} legend" |
* | * | "{shownFormatted} of {totalFormatted} legends" |
*
* @param {Meta_Shown_Legends_PartialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_shown_legends_partial = /** @type {((inputs: Meta_Shown_Legends_PartialInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Shown_Legends_PartialInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const totalPlural = registry.plural("de", i?.total, {}, true);
		const shownFormatted = registry.number("de", i?.shown, {}, true);
		const totalFormatted = registry.number("de", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} von ${totalFormatted} Legende`);
		return /** @type {LocalizedString} */ (`${shownFormatted} von ${totalFormatted} Legenden`)
	}
	if (locale === "fr") {
		const totalPlural = registry.plural("fr", i?.total, {}, true);
		const shownFormatted = registry.number("fr", i?.shown, {}, true);
		const totalFormatted = registry.number("fr", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} sur ${totalFormatted} légende`);
		return /** @type {LocalizedString} */ (`${shownFormatted} sur ${totalFormatted} légendes`)
	}
	if (locale === "zh-Hans") {
		const totalPlural = registry.plural("zh-Hans", i?.total, {}, true);
		const shownFormatted = registry.number("zh-Hans", i?.shown, {}, true);
		const totalFormatted = registry.number("zh-Hans", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 个传奇中的 ${shownFormatted} 个`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 个传奇中的 ${shownFormatted} 个`)
	}
	if (locale === "zh-Hant") {
		const totalPlural = registry.plural("zh-Hant", i?.total, {}, true);
		const shownFormatted = registry.number("zh-Hant", i?.shown, {}, true);
		const totalFormatted = registry.number("zh-Hant", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 位傳奇中的 ${shownFormatted} 位`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 位傳奇中的 ${shownFormatted} 位`)
	}
	if (locale === "ko") {
		const totalPlural = registry.plural("ko", i?.total, {}, true);
		const shownFormatted = registry.number("ko", i?.shown, {}, true);
		const totalFormatted = registry.number("ko", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`전설 ${totalFormatted}개 중 ${shownFormatted}개`);
		return /** @type {LocalizedString} */ (`전설 ${totalFormatted}개 중 ${shownFormatted}개`)
	}
	{
		const totalPlural = registry.plural("en", i?.total, {}, true);
		const shownFormatted = registry.number("en", i?.shown, {}, true);
		const totalFormatted = registry.number("en", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} of ${totalFormatted} legend`);
		return /** @type {LocalizedString} */ (`${shownFormatted} of ${totalFormatted} legends`)
	}
});